import api from './api';

export function getPerfilUsuario() {
    return api.get(`perfil_usuario`);
}
